import styled from 'styled-components';

export const ListContainer = styled.div`
  display: flex;
  padding: 0px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
